/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type InternetConnectionTypeEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;

export const InternetConnectionTypeEnum = {
    NUMBER_1: 1 as InternetConnectionTypeEnum,
    NUMBER_2: 2 as InternetConnectionTypeEnum,
    NUMBER_3: 3 as InternetConnectionTypeEnum,
    NUMBER_4: 4 as InternetConnectionTypeEnum,
    NUMBER_5: 5 as InternetConnectionTypeEnum,
    NUMBER_6: 6 as InternetConnectionTypeEnum,
    NUMBER_7: 7 as InternetConnectionTypeEnum,
    NUMBER_8: 8 as InternetConnectionTypeEnum,
    NUMBER_9: 9 as InternetConnectionTypeEnum
};

